/*
 * @Descripttion:
 * @Author: sjq
 * @Date: 2021-03-19 09:37:55
 * @LastEditors: sjq
 * @LastEditTime: 2022-07-25 17:09:52
 */
import { request } from '@/utils/request'

// 6.1. 根据行政编码获取下一级别的行政区域列表
export function getRegions(params) {
  return request({
    url: '/sgsf-platform/regions/admin',
    method: 'GET',
    params
  })
}
// 获取门店列表
export function getSchoolList(params) {
  let range = params?.range || 3
  return request({
    url: '/sgsf-platform/agents/list?range=' + range,
    method: 'GET',
    params
  })
}
// 7.3. 查询用户信息
export function getUserInfo(params) {
  return request({
    url: '/sgsf-platform/sys-users/info',
    method: 'GET',
    params
  })
}
// 7.4. 用户密码重置
export function reserPassword(data) {
  return request({
    url: '/sgsf-platform/sys-users/password/reset',
    method: 'post',
    data
  })
}

export function setSortCommon(data, type) {
  if (!type) {
    console.error('请设置排序关键字')
    return
  }
  let url = ``
  let method = 'put'
  switch (type) {
    case 'barragePreinstall':
      url = `sgsf-operation/expression/${data.id}/sort/${data.sortValue}?expressionType=${data.expressionType}`
      break
    case 'studyPlanTemplate':
      url = `sgsf-course-scheduling/course/template/${data.id}`
      data = { id: data.id, sorted: data.sortValue }
      break
    case 'goodsSort':
      url = `sgsf-taojinwu/goods/sort`
      data = { goodsId: data.id, sort: data.sortValue }
      method = 'post'
      break
  }
  return request({
    url: url,
    method: method,
    data
  })
}
// 获取课程接口五级联动
export function getCourseStructure(params) {
  return request({
    url: '/sgsf-platform/course-modules/course-structure',
    method: 'get',
    params
  })
}

export function getSubjectList(params) {
  return request({
    url: '/sgsf-common-interface/dicts/knowledge-init',
    method: 'get',
    params
  })
}

export function getSubjectsList(params) {
  return request({
    url: '/sgsf-common-interface/dicts/knowledge-json-init',
    method: 'get',
    params
  })
}

// 5.5. 会员学段知识链初始化(学段内层级)
export function getStuSubjectsList2(params) {
  return request({
    url: '/sgsf-common-interface/dicts/stu-knowledge-json-init-2',
    method: 'get',
    params
  })
}
// 获取学段年级
export function getStuGradeList(params) {
  return request({
    url: '/sgsf-common-interface/dicts/grade',
    method: 'get',
    params
  })
}

// 1.3. 获取门店待办
export function getGlobalTodo(params) {
  return request({
    url: '/sgsf-agency/global-setting/todo',
    method: 'get',
    params: {
      keys: 'g_barrage_mgr'
    }
  })
}
// 2.2. 通过类型获取字典列表(批量)
export function getDictLists(params) {
  return request({
    url: '/sgsf-common-interface/dicts/batch',
    method: 'get',
    params
  })
}

export function getAgtSearchList(params) {
  return request({
    url: '/sgsf-taojinwu/mercantile/agt/list',
    method: 'get',
    params
  })
}

export function getStuSubjectsJson2(params) {
  return request({
    url: '/sgsf-common-interface/knowledge/tree',
    method: 'get',
    params
  })
}

export function getStuSubjectsJson3(params) {
  return request({
    url: '/sgsf-common-interface/knowledge/tree/v1',
    method: 'get',
    params
  })
}

export function getBookStructure(params) {
  return request({
    url: '/sgsf-platform/recite/book-structure',
    params
  })
}
export function getRecitePoints(params) {
  return request({
    url: '/sgsf-platform/recite/point/points',
    method: 'get',
    params
  })
}


